var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"100",
      name:"用户权限管理",
      parentId:"USER_ID",
      parentName:"用户管理",
      parentPath:"/system/userManagement",
      parentQuery:{
      },
      addForm:{
      },
      dataClass:3,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }